/**
 * # 音乐动机参数配置表
 *
 * 控制不同游戏事件（消行类型）对应的音效参数变化， 用于在播放消行音效时根据消除行数调整音高、速度和音量。
 *
 * ## 事件类型
 *
 * | 动机      | 触发条件              | 说明                             |
 * | --------- | --------------------- | -------------------------------- |
 * | `combo`   | 消除 1-3 行           | 标准音效                         |
 * | `tetris`  | 消除 4 行             | 音调提高，速度加快，音量增大     |
 * | `perfect` | 全清（Perfect Clear） | 音调大幅提高，速度稍慢，音量最大 |
 *
 * ## 参数说明
 *
 * | 参数     | 说明                                 |
 * | -------- | ------------------------------------ |
 * | `shift`  | 音高偏移（半音单位），值越大音调越高 |
 * | `speed`  | 播放速度倍率，> 1 加快，< 1 减慢     |
 * | `volume` | 音量倍率，> 1 增大                   |
 *
 * @constant {object} MOTIFS
 */
const MOTIFS = {
  /** ## 普通消行（1-3 行）：标准参数 */
  combo: {
    shift: 0,
    speed: 1,
    volume: 1,
  },

  /** ## 俄罗斯方块（4 行）：音调提高，加速，音量增大 */
  tetris: {
    shift: 2,
    speed: 1.2,
    volume: 1.1,
  },

  /** ## 全清（Perfect Clear）：音调大幅提高，稍慢，音量最大 */
  perfect: {
    shift: 5,
    speed: 0.9,
    volume: 1.3,
  },
};

export default MOTIFS;
